// eslint-disable-next-line
import { German } from 'flatpickr/dist/l10n/de';

export default {
  dateConfig: {
    disableMobile: false,
    altInput: true,
    altFormat: 'd-m-Y',
    dateFormat: 'Y-m-d H:i:S',
    locale: German,
    enableTime: false,
  },
  dateConfigTime: {
    disableMobile: true,
    altInput: true,
    altFormat: 'd-m-Y H:i',
    dateFormat: 'Y-m-d H:i:S',
    locale: German,
    enableTime: true,
  },
  stopwatch: {
    time: '00:00:00',
    timeBegan: null,
    timeStopped: null,
  },
  workTime: null,
  workTimeId: null,
  credit: 0,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/state.js